import type { StatisticsResponse } from "@warrenio/api-spec/spec.oats.gen";

export function makeServicePackageExample(loc: string): StatisticsResponse {
    return [
        {
            billing_account_id: 131352,
            created_at: "2025-07-04 09:33:53",
            display_name: "maria",
            is_deleted: false,
            is_multi_node: false,
            prices: [
                {
                    priceMultiplier: 3.0,
                    resourceType: "CPU",
                },
                {
                    priceMultiplier: 3.0,
                    resourceType: "RAM",
                },
                {
                    priceMultiplier: 3.0,
                    resourceType: "STORAGE",
                    serviceNameInUptime: "main",
                },
                {
                    priceMultiplier: 3.0,
                    resourceType: "STORAGE",
                    serviceNameInUptime: "block",
                },
                {
                    priceMultiplier: 0.0,
                    resourceType: "STORAGE",
                    serviceNameInUptime: "snapshot",
                },
                {
                    priceMultiplier: 0.0,
                    resourceType: "STORAGE",
                    serviceNameInUptime: "backup",
                },
                {
                    priceMultiplier: 0.0,
                    resourceType: "OBJECT_STORAGE",
                },
                {
                    priceMultiplier: 0.0,
                    resourceType: "LICENSE",
                    serviceNameInUptime: "windows",
                },
                {
                    priceMultiplier: 0.0,
                    resourceType: "UNASSIGNED_FLOATING_IP",
                },
                {
                    price_multiplier: 3.0,
                    resource_type: "CPU",
                },
                {
                    price_multiplier: 3.0,
                    resource_type: "RAM",
                },
                {
                    price_multiplier: 3.0,
                    resource_type: "BLOCK_STORAGE",
                },
                {
                    price_multiplier: 0.0,
                    resource_type: "BLOCK_STORAGE_SNAPSHOT",
                },
                {
                    price_multiplier: 0.0,
                    resource_type: "BLOCK_STORAGE_BACKUP",
                },
                {
                    price_multiplier: 0.0,
                    resource_type: "OBJECT_STORAGE",
                },
                {
                    price_multiplier: 0.0,
                    resource_type: "WINDOWS_LICENSE",
                },
                {
                    price_multiplier: 0.0,
                    resource_type: "UNASSIGNED_FLOATING_IP",
                },
            ],
            properties: {
                service_ip: "10.2.189.233",
                location: loc,
                sql_user: "wadmin",
                port: 3306,
            },
            resources: [
                {
                    resource_allocation: {
                        memory: 1024,
                        vcpu: 2,
                        status: "running",
                        storage: [
                            {
                                primary: true,
                                size: 20,
                                uuid: "dbb980a8-081e-4f3c-a7fc-da0b0701755e",
                                replica: [
                                    {
                                        created_at: "2025-11-17 01:30:44",
                                        size: 20,
                                        type: "backup",
                                        uuid: "d052bdbb-a42a-4737-a024-38262b240d57",
                                    },
                                    {
                                        created_at: "2025-11-16 01:30:44",
                                        size: 20,
                                        type: "backup",
                                        uuid: "6ab588d9-052b-4658-9b5e-7a7497509ab1",
                                    },
                                    {
                                        created_at: "2025-11-15 01:30:43",
                                        size: 20,
                                        type: "backup",
                                        uuid: "465c6e66-7fbc-4424-b42d-6cfa2df00b08",
                                    },
                                    {
                                        created_at: "2025-11-14 01:30:48",
                                        size: 20,
                                        type: "backup",
                                        uuid: "26544cf7-5d6b-4399-ae25-52de97718dba",
                                    },
                                    {
                                        created_at: "2025-11-13 01:30:47",
                                        size: 20,
                                        type: "backup",
                                        uuid: "8ed70c8a-a384-495b-a214-9cf613d1da0f",
                                    },
                                    {
                                        created_at: "2025-11-12 01:30:41",
                                        size: 20,
                                        type: "backup",
                                        uuid: "f2ba148f-762f-4bac-873c-acd65d1c1c53",
                                    },
                                    {
                                        created_at: "2025-11-11 01:30:40",
                                        size: 20,
                                        type: "backup",
                                        uuid: "8c6c593d-3ca5-4cdd-9bc0-aa3cf4dd1aad",
                                    },
                                ],
                            },
                        ],
                    },
                    resource_id: "e5992f17-2b0b-47e2-8bed-485e39dc8273",
                    resource_location: loc,
                    resource_type: "vm",
                },
            ],
            service: "mariadb",
            status: "active",
            updated_at: "2025-07-04 09:34:48",
            user_id: 136,
            uuid: "2dd22c9b-9357-4dd1-984a-4e5aaadc133e",
            version: "11.4",
        },
        {
            billing_account_id: 131352,
            created_at: "2025-02-12 11:36:38",
            display_name: "PostgreSQL",
            is_deleted: false,
            is_multi_node: true,
            prices: [
                {
                    priceMultiplier: 3.0,
                    resourceType: "CPU",
                },
                {
                    priceMultiplier: 3.0,
                    resourceType: "RAM",
                },
                {
                    priceMultiplier: 3.0,
                    resourceType: "STORAGE",
                    serviceNameInUptime: "main",
                },
                {
                    priceMultiplier: 3.0,
                    resourceType: "STORAGE",
                    serviceNameInUptime: "block",
                },
                {
                    priceMultiplier: 0.0,
                    resourceType: "STORAGE",
                    serviceNameInUptime: "snapshot",
                },
                {
                    priceMultiplier: 0.0,
                    resourceType: "STORAGE",
                    serviceNameInUptime: "backup",
                },
                {
                    priceMultiplier: 0.0,
                    resourceType: "OBJECT_STORAGE",
                },
                {
                    priceMultiplier: 0.0,
                    resourceType: "LICENSE",
                    serviceNameInUptime: "windows",
                },
                {
                    priceMultiplier: 0.0,
                    resourceType: "UNASSIGNED_FLOATING_IP",
                },
                {
                    price_multiplier: 3.0,
                    resource_type: "CPU",
                },
                {
                    price_multiplier: 3.0,
                    resource_type: "RAM",
                },
                {
                    price_multiplier: 3.0,
                    resource_type: "BLOCK_STORAGE",
                },
                {
                    price_multiplier: 0.0,
                    resource_type: "BLOCK_STORAGE_SNAPSHOT",
                },
                {
                    price_multiplier: 0.0,
                    resource_type: "BLOCK_STORAGE_BACKUP",
                },
                {
                    price_multiplier: 0.0,
                    resource_type: "OBJECT_STORAGE",
                },
                {
                    price_multiplier: 0.0,
                    resource_type: "WINDOWS_LICENSE",
                },
                {
                    price_multiplier: 0.0,
                    resource_type: "UNASSIGNED_FLOATING_IP",
                },
            ],
            properties: {
                service_ip: "10.2.189.156",
                location: loc,
                sql_user: "wadmin",
                port: 5432,
            },
            resources: [
                {
                    resource_allocation: {},
                    resource_id: "05b999d7-88a8-41be-b947-f61e301ce2bd",
                    resource_location: loc,
                    resource_type: "virtual_ip",
                },
                {
                    resource_allocation: {},
                    resource_id: "29243843-cf01-4f75-9b19-5e2d838fb08d",
                    resource_location: loc,
                    resource_type: "vm",
                },
                {
                    resource_allocation: {},
                    resource_id: "9d20dbfe-7cbb-4ce3-b70f-bdf5520837fd",
                    resource_location: loc,
                    resource_type: "vm",
                },
            ],
            service: "postgresql",
            status: "active",
            updated_at: "2025-02-12 11:41:48",
            user_id: 136,
            uuid: "38260316-84de-48b1-a30b-e77b7a5c9b41",
            version: "13.4",
        },
        {
            billing_account_id: 131352,
            created_at: "2024-03-22 09:45:06",
            display_name: "kube",
            is_deleted: false,
            is_multi_node: false,
            prices: [
                {
                    priceMultiplier: 3.0,
                    resourceType: "CPU",
                },
                {
                    priceMultiplier: 3.0,
                    resourceType: "RAM",
                },
                {
                    priceMultiplier: 3.0,
                    resourceType: "STORAGE",
                    serviceNameInUptime: "main",
                },
                {
                    priceMultiplier: 3.0,
                    resourceType: "STORAGE",
                    serviceNameInUptime: "block",
                },
                {
                    priceMultiplier: 0.0,
                    resourceType: "STORAGE",
                    serviceNameInUptime: "snapshot",
                },
                {
                    priceMultiplier: 0.0,
                    resourceType: "STORAGE",
                    serviceNameInUptime: "backup",
                },
                {
                    priceMultiplier: 0.0,
                    resourceType: "OBJECT_STORAGE",
                },
                {
                    priceMultiplier: 0.0,
                    resourceType: "LICENSE",
                    serviceNameInUptime: "windows",
                },
                {
                    priceMultiplier: 0.0,
                    resourceType: "UNASSIGNED_FLOATING_IP",
                },
                {
                    price_multiplier: 3.0,
                    resource_type: "CPU",
                },
                {
                    price_multiplier: 3.0,
                    resource_type: "RAM",
                },
                {
                    price_multiplier: 3.0,
                    resource_type: "BLOCK_STORAGE",
                },
                {
                    price_multiplier: 0.0,
                    resource_type: "BLOCK_STORAGE_SNAPSHOT",
                },
                {
                    price_multiplier: 0.0,
                    resource_type: "BLOCK_STORAGE_BACKUP",
                },
                {
                    price_multiplier: 0.0,
                    resource_type: "OBJECT_STORAGE",
                },
                {
                    price_multiplier: 0.0,
                    resource_type: "WINDOWS_LICENSE",
                },
                {
                    price_multiplier: 0.0,
                    resource_type: "UNASSIGNED_FLOATING_IP",
                },
            ],
            properties: {
                location: loc,
                cluster_name: "240322378b6604",
                spec: {
                    hibernation: {
                        enabled: true,
                    },
                    kubernetes: {
                        kubeAPIServer: {
                            requests: {
                                maxNonMutatingInflight: 400,
                                maxMutatingInflight: 200,
                            },
                            enableAnonymousAuthentication: false,
                            eventTTL: "1h0m0s",
                            logging: {
                                verbosity: 2,
                            },
                            defaultNotReadyTolerationSeconds: 300,
                            defaultUnreachableTolerationSeconds: 300,
                        },
                        kubeControllerManager: {
                            nodeCIDRMaskSize: 24,
                            nodeMonitorGracePeriod: "2m0s",
                        },
                        kubeScheduler: {
                            profile: "balanced",
                        },
                        kubeProxy: {
                            mode: "IPTables",
                            enabled: true,
                        },
                        kubelet: {
                            failSwapOn: true,
                            kubeReserved: {
                                cpu: "80m",
                                memory: "1Gi",
                                pid: "20k",
                            },
                            imageGCHighThresholdPercent: 50,
                            imageGCLowThresholdPercent: 40,
                            serializeImagePulls: true,
                        },
                        version: "1.26.13",
                        verticalPodAutoscaler: {
                            enabled: true,
                            evictAfterOOMThreshold: "10m0s",
                            evictionRateBurst: 1,
                            evictionRateLimit: -1,
                            evictionTolerance: 0.5,
                            recommendationMarginFraction: 0.15,
                            updaterInterval: "1m0s",
                            recommenderInterval: "1m0s",
                        },
                        enableStaticTokenKubeconfig: true,
                    },
                    maintenance: {
                        autoUpdate: {
                            kubernetesVersion: true,
                            machineImageVersion: true,
                        },
                        timeWindow: {
                            begin: "030000+0200",
                            end: "040000+0200",
                        },
                    },
                    networking: {
                        type: "calico",
                        providerConfig: {
                            apiVersion: "calico.networking.extensions.gardener.cloud/v1alpha1",
                            kind: "NetworkConfig",
                            typha: {
                                enabled: false,
                            },
                        },
                        pods: "10.1.0.0/16",
                        nodes: "10.22.206.0/24",
                        services: "10.2.0.0/16",
                        ipFamilies: ["IPv4"],
                    },
                    provider: {
                        type: "warren",
                        controlPlaneConfig: {
                            apiEndpointURL: "https://test-api.pilw.io/v1/tll",
                            apiVersion: "warren.provider.extensions.gardener.cloud/v1alpha1",
                            kind: "ControlPlaneConfig",
                            zone: "tll",
                        },
                        infrastructureConfig: {
                            apiEndpointURL: "https://test-api.pilw.io/v1/tll",
                            apiVersion: "warren.provider.extensions.gardener.cloud/v1alpha1",
                            kind: "InfrastructureConfig",
                            networks: {
                                workersConfiguration: {
                                    zone: "tll",
                                },
                            },
                        },
                        workers: [
                            {
                                cri: {
                                    name: "containerd",
                                },
                                name: "worker-op8s7g",
                                machine: {
                                    image: {
                                        name: "ubuntu",
                                        version: "24.04",
                                    },
                                    architecture: "amd64",
                                    vcpu: 2,
                                    ram: 2048,
                                },
                                maximum: 5,
                                minimum: 1,
                                maxSurge: 1,
                                maxUnavailable: 0,
                                volume: {
                                    size: "40Gi",
                                },
                                zones: ["tll"],
                                systemComponents: {
                                    allow: true,
                                },
                            },
                        ],
                        workersSettings: {
                            sshAccess: {
                                enabled: true,
                            },
                        },
                    },
                },
                status: {
                    conditions: [
                        {
                            type: "APIServerAvailable",
                            status: "True",
                            lastTransitionTime: "2024-09-17T12:47:34Z",
                            lastUpdateTime: "2024-09-17T12:47:34Z",
                            reason: "ConditionNotChecked",
                            message: "Shoot cluster has been hibernated.",
                        },
                        {
                            type: "ControlPlaneHealthy",
                            status: "True",
                            lastTransitionTime: "2024-09-17T12:47:34Z",
                            lastUpdateTime: "2024-09-17T12:47:34Z",
                            reason: "ConditionNotChecked",
                            message: "Shoot cluster has been hibernated.",
                        },
                        {
                            type: "ObservabilityComponentsHealthy",
                            status: "True",
                            lastTransitionTime: "2024-09-17T12:47:34Z",
                            lastUpdateTime: "2024-09-17T12:47:34Z",
                            reason: "ConditionNotChecked",
                            message: "Shoot cluster has been hibernated.",
                        },
                        {
                            type: "EveryNodeReady",
                            status: "True",
                            lastTransitionTime: "2024-09-17T12:47:34Z",
                            lastUpdateTime: "2024-09-17T12:47:34Z",
                            reason: "ConditionNotChecked",
                            message: "Shoot cluster has been hibernated.",
                        },
                        {
                            type: "SystemComponentsHealthy",
                            status: "True",
                            lastTransitionTime: "2024-09-17T12:47:34Z",
                            lastUpdateTime: "2024-09-17T12:47:34Z",
                            reason: "ConditionNotChecked",
                            message: "Shoot cluster has been hibernated.",
                        },
                    ],
                    constraints: [
                        {
                            type: "HibernationPossible",
                            status: "True",
                            lastTransitionTime: "2024-09-17T12:47:34Z",
                            lastUpdateTime: "2024-09-17T12:47:34Z",
                            reason: "ConstraintNotChecked",
                            message: "Shoot cluster has been hibernated.",
                        },
                        {
                            type: "MaintenancePreconditionsSatisfied",
                            status: "True",
                            lastTransitionTime: "2024-09-17T12:47:34Z",
                            lastUpdateTime: "2024-09-17T12:47:34Z",
                            reason: "ConstraintNotChecked",
                            message: "Shoot cluster has been hibernated.",
                        },
                        {
                            type: "CACertificateValiditiesAcceptable",
                            status: "True",
                            lastTransitionTime: "2024-03-22T09:53:12Z",
                            lastUpdateTime: "2024-03-22T09:53:12Z",
                            reason: "ConstraintNotChecked",
                            message: "Shoot cluster has been hibernated.",
                        },
                        {
                            type: "CRDsWithProblematicConversionWebhooks",
                            status: "True",
                            lastTransitionTime: "2024-03-22T09:53:12Z",
                            lastUpdateTime: "2024-03-22T09:53:12Z",
                            reason: "ConstraintNotChecked",
                            message: "Shoot cluster has been hibernated.",
                        },
                    ],
                    gardener: {
                        id: "5wbHRJXAYVn5EZvGTwX9wUkUeSXwIfY3fTqtqckbe7X9yBXjCZuIUi8cB9zLhQtu",
                        name: "gardenlet-6695854bcb-958pf",
                        version: "v1.87.3",
                    },
                    hibernated: true,
                    lastOperation: {
                        description:
                            'Shoot cannot be synced with Seed: seed is not yet ready: condition "SeedSystemComponentsHealthy" has invalid status False (expected True) due to DeploymentUnhealthy: Deployment "garden/etcd-druid" is unhealthy: condition "Available" has invalid status False (expected True) due to MinimumReplicasUnavailable: Deployment does not have minimum availability.',
                        lastUpdateTime: "2024-09-18T12:49:57Z",
                        progress: 0,
                        state: "Processing",
                        type: "Reconcile",
                    },
                    observedGeneration: 156,
                    retryCycleStartTime: "2024-09-17T01:36:18Z",
                    seedName: "local",
                    technicalID: "shoot--local--240322378b6604",
                    uid: "2a01fdac-a2a8-4a66-8f21-03e033ffacab",
                    clusterIdentity:
                        "shoot--local--240322378b6604-2a01fdac-a2a8-4a66-8f21-03e033ffacab-garden-cluster-identity",
                    advertisedAddresses: [
                        {
                            name: "external",
                            url: "https://api.240322378b6604.local.external.test.pilw.gardendev.wrrnk8s.com",
                        },
                        {
                            name: "internal",
                            url: "https://api.240322378b6604.local.internal.ingress.local.test.pilw.gardendev.wrrnk8s.com",
                        },
                    ],
                    lastErrors: [
                        {
                            description:
                                'task "Waiting until shoot worker nodes have been reconciled" failed: Error while waiting for Worker shoot--local--240322378b6604/240322378b6604 to become ready: error during reconciliation: Error reconciling Worker: failed to generate the machine deployments: could not find machine image for ubuntu/24.04 neither in cloud profile nor in worker status',
                            taskID: "Waiting until shoot worker nodes have been reconciled",
                            lastUpdateTime: "2024-04-09T17:02:27Z",
                        },
                    ],
                    lastMaintenance: {
                        description:
                            'All maintenance operations successful. Worker pool "worker-op8s7g": Updated machine image "ubuntu" from "22.04" to "24.04". Reason: Automatic update of the machine image version is configured (image update strategy: major)',
                        triggeredTime: "2024-03-23T01:30:15Z",
                        state: "Succeeded",
                    },
                },
            },
            resources: [
                {
                    resource_allocation: {},
                    resource_id: "d222d534-5859-4c4a-ae95-089862cbe14f",
                    resource_location: loc,
                    resource_type: "network",
                },
                {
                    resource_allocation: {},
                    resource_id: "5842",
                    resource_type: "kong_token",
                },
            ],
            service: "kubernetes",
            status: "active",
            updated_at: "2025-07-04 08:06:55",
            user_id: 136,
            uuid: "378b6604-5a88-4a2c-b396-636835641fe9",
            version: "1.26.13",
        },
    ];
}
